import { useEffect, type ReactNode } from 'react';

/** Overlay closes on click outside or Escape. */
export function Modal({ title, subtitle, onClose, children, width }: { title: string; subtitle?: ReactNode; onClose: () => void; children: ReactNode; width?: number }) {
  useEffect(() => {
    const esc = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', esc);
    return () => document.removeEventListener('keydown', esc);
  }, [onClose]);
  return (
    <div className="modal-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal" role="dialog" aria-modal="true" aria-label={title} style={width ? { width } : undefined}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <span className="modal__title">{title}</span>
          {subtitle && <span className="modal__sub">{subtitle}</span>}
        </div>
        {children}
      </div>
    </div>
  );
}
